import { UniDriver } from '@wix/unidriver-core';
import {
  baseUniDriverFactory,
  findByHook,
} from '../utils/test-utils/unidriver';
import { dataHooks } from './Timeline.constants';

export type TimelineUniDriver = ReturnType<typeof timelineDriverFactory>;

export const timelineDriverFactory = (base: UniDriver) => {
  return {
    ...baseUniDriverFactory(base),

    /**
     * Gets the label text of timeline item by index
     * @param timeline item index
     * @returns timeline item label text at index
     */
    getLabelText: async (idx: number): Promise<string> =>
      await findByHook(base, `${dataHooks.timelineLabel}-${idx}`).text(),

    /**
     * Get the suffix text of timeline item  by index
     * @param timeline item index
     * @returns timeline item suffix text at index
     */
    getSuffixText: async (idx: number): Promise<string> =>
      await findByHook(base, `${dataHooks.timelineTextSuffix}-${idx}`).text(),

    /**
     * Gets skin type
     * @return {Promise<'dark' | 'neutral' | 'standard'>}
     */
    getSkin: async () => await base.attr('data-skin'),
  };
};
